module.exports = __webpack_public_path__ + "static/inspiring_leader-1b11bbc297b1c5297f60677fcb5cc701.jpg";